import React from 'react';
import { ArrowRight } from 'lucide-react';
import { poutineImage } from '../mock';

const FeaturedDish = () => {
  return (
    <section className="bg-[#2a1a0f] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative rounded-2xl overflow-hidden aspect-[5/4] order-2 lg:order-1">
            <img src={poutineImage} alt="Bliss poutine" className="w-full h-full object-cover" />
            <div className="absolute top-5 left-5 bg-[#f4ead4]/95 text-[#2a1a0f] text-[11px] tracking-[0.14em] font-medium uppercase px-4 py-2 rounded-full">
              Local Favourite
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="text-[12px] tracking-[0.16em] font-medium text-[#c88a3a] uppercase mb-5">
              The Bliss Classic
            </div>
            <h2 className="font-serif text-[46px] sm:text-[56px] lg:text-[64px] leading-[1.05] text-[#f4ead4] tracking-tight">
              Come hungry for the poutine.
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-[#c9b394] max-w-xl">
              Crisp golden fries, cheese curds and rich gravy—served hot and made for the kind of
              craving only poutine can fix.
            </p>

            <div className="mt-10 pt-6 border-t border-[#f4ead4]/15 flex items-center justify-between">
              <span className="font-serif text-[26px] text-[#f4ead4]">Bliss poutine</span>
              <span className="text-[20px] text-[#c88a3a]">$8.58 / $10.48</span>
            </div>

            <button
              onClick={() => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' })}
              className="group mt-10 inline-flex items-center gap-3 bg-[#f4ead4]/10 hover:bg-[#f4ead4]/20 border border-[#f4ead4]/20 text-[#f4ead4] px-6 py-3.5 rounded-full transition-colors"
            >
              <span className="text-[15px]">See the full menu</span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedDish;
